import { cloneDeep } from 'lodash';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
export var state = {
    job: null,
    forms: [],
    loadingForms: false,
};
export var types = {
    SET_FORMS: 'setForms',
    SET_LOADING_FORMS: 'setLoadingForms',
};
export var currentJob = {
    namespaced: true,
    state: cloneDeep(state),
    getters: getters,
    actions: actions,
    mutations: mutations,
};
